import React from 'react';
import { VtxIcon } from '../icon/VtxIcon';

export const baseSelectDataAutomationClass = 'vtx-select';

export const arrowIconProp = {
    suffixIcon: <VtxIcon type="down" fontSize={'14px'} />,
};
